import { motion } from "framer-motion";
import { ArrowDown, GraduationCap, BookOpen, Briefcase, Landmark, Rocket, BadgeDollarSign } from "lucide-react";
import { Reveal } from "../landing/Reveal";

const FLOW = [
  { icon: GraduationCap, label: "Students" },
  { icon: BookOpen, label: "LearnNova" },
  { icon: Briefcase, label: "CareerNova" },
  { icon: Landmark, label: "FundNova" },
  { icon: Rocket, label: "Entrepreneurship" },
  { icon: BadgeDollarSign, label: "Revenue" },
];

export const EcosystemFlow = () => (
  <section id="ecosystem" data-testid="ecosystem-flow" className="relative overflow-hidden py-24 sm:py-32">
    <div aria-hidden="true" className="absolute left-1/2 top-1/2 h-[480px] w-[480px] -translate-x-1/2 -translate-y-1/2 rounded-full bg-[#00D26A]/[0.06] blur-[160px]" />
    <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8">
      <Reveal className="text-center">
        <p className="font-jbmono text-xs uppercase tracking-[0.3em] text-[#00D26A]">
          FUNZ Ecosystem
        </p>
        <h2 className="mx-auto mt-4 max-w-2xl font-display text-3xl font-extrabold tracking-tight text-white sm:text-4xl lg:text-5xl">
          From first class to first revenue.
        </h2>
      </Reveal>

      <div className="mx-auto mt-16 flex max-w-md flex-col items-center" data-testid="ecosystem-chain">
        {FLOW.map((f, i) => (
          <div key={f.label} className="flex w-full flex-col items-center">
            <Reveal delay={0.08 * i} className="w-full">
              <div
                data-testid={`flow-node-${f.label.toLowerCase()}`}
                className="group flex w-full items-center gap-4 rounded-2xl border border-white/10 bg-[#111827]/90 px-6 py-4 backdrop-blur-xl transition-colors hover:border-[#635BFF]/50"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-[#635BFF]/25 to-[#00D26A]/15">
                  <f.icon className="h-5 w-5 text-[#00D26A]" />
                </span>
                <p className="font-display text-lg font-bold text-white">{f.label}</p>
                <span className="ml-auto font-jbmono text-[10px] uppercase tracking-widest text-slate-600">
                  0{i + 1}
                </span>
              </div>
            </Reveal>
            {i < FLOW.length - 1 && (
              <motion.div
                aria-hidden="true"
                animate={{ y: [0, 6, 0], opacity: [0.4, 1, 0.4] }}
                transition={{ duration: 1.6, repeat: Infinity, delay: i * 0.25, ease: "easeInOut" }}
                className="py-2"
              >
                <ArrowDown className="h-5 w-5 text-[#00D26A]" />
              </motion.div>
            )}
          </div>
        ))}
      </div>
    </div>
  </section>
);
